import React, { memo, useEffect, useRef, useState } from 'react';
import { instantiateModel } from "./instantiateModel";

const ExerciseCanvas = ({ exercise, width = 188, height = 188, ...props }) => {
  const [data, setData] = useState(null)
  const canvasRef = useRef(null)

  // Redraw canvas on data change
  useEffect(() => { drawPreview() }, [data, canvasRef]);
  useEffect(() => {
    const { diagram_data, image } = exercise;
    if (!diagram_data) return;
 
    let filteredData = diagram_data;
    if (typeof diagram_data === 'string') {
      filteredData = JSON.parse(diagram_data)
    }
    if (image) {
      filteredData = { ...filteredData, transparent: true, objects: filteredData?.objects?.filter(item => !!item.hotspot_type) }
    } else {
      filteredData = { ...filteredData, transparent: false }
    }

    setData(filteredData)
  }, [exercise]);

  const drawPreview = () => {
    const canvas = canvasRef.current
    const ctx = canvas?.getContext('2d')

    ctx && DrawCanvas(data, ctx);
  }

  return (
    <div className="exercise-diagram-container" style={{ width, height}}>
      {exercise?.image && <img className="exercise-diagram-container-image" src={exercise?.image} alt={exercise?.title} style={{ width, height}}/>}
      <canvas ref={canvasRef} className="exercise-diagram-container-canvas" {...{ width, height, ...props }}>Exercise Preview</canvas>
    </div>
  )
};

export default memo(ExerciseCanvas);


const DrawCanvas = (data, ctx) => {
  if (!data || !ctx) return;

  if (typeof data === 'string') {
    data = JSON.parse(data)
  }

  const canvas_height = ctx.canvas.height
  const canvas_width = ctx.canvas.width

  ctx.scale = canvas_width / data.field_size[0];

  if (!data.transparent) {
    ctx.fillStyle = "rgba(28, 134, 80, 1)";
    ctx.fillRect(0, 0, canvas_width, canvas_height);

    for (let i = 0; i < 12; i = i + 2) {
      let h = canvas_height / 11;
      ctx.fillStyle = "rgba(27, 130, 78, 1)";
      ctx.fillRect(0, i * h, canvas_width, h);
    }  
  } else {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  }

  for (const i in data.objects) {
    const object = instantiateModel(data.objects[i], ctx)

    object.render();
  }

}
